import { Button, Typography } from '@grammarly/badger-ui'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconClose } from '../../../../ui-lib/icons/close'

import styles from './not-enough-text-alert.module.scss'

const { C5 } = Typography

interface TextCheckerNotEnoughTextAlertProps {
  onUseSampleText: () => void
  onClose: () => void
}

export const TextCheckerNotEnoughTextAlert = (props: TextCheckerNotEnoughTextAlertProps) => {
  const intl = useIntl()
  return (
    <div className={styles.notEnoughTextAlert} role="alert">
      <C5 as="div">
        <FormattedMessage
          id="textChecker.reportFlow.notEnoughTextAlert.error"
          description="Text Checker - Report Flow - Not Enough Text Alert - Error"
          defaultMessage="Not enough text to check!{lineBreak}Add more words or {link} to see Grammarly's feedback"
          values={{
            lineBreak: <br />,
            link: (
              <Button
                className={styles.sampleTextButton}
                padding="none"
                onClick={() => {
                  props.onUseSampleText()
                  props.onClose()
                }}
              >
                <FormattedMessage
                  id="textChecker.reportFlow.notEnoughTextAlert.ctaText"
                  description="Text Checker - Report Flow - Not Enough Text Alert - CTA Text"
                  defaultMessage="use our sample text"
                />
              </Button>
            ),
          }}
        />
      </C5>
      <Button
        className={styles.closeButton}
        onClick={props.onClose}
        padding="none"
        aria-label={intl.formatMessage({
          id: 'global.uiAction.close',
          description: 'Text for CTA that closes an element',
          defaultMessage: 'Close',
        })}
      >
        <IconClose aria-hidden="true" />
      </Button>
    </div>
  )
}
